<template>
  <p :id="description">
    <slot />
  </p>
</template>

<script>
export default {
  name: "DoeError",
  props: {
    description: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  @apply font-sans mt-1 subpixel-antialiased text-sm;
  color: #d0021b;
}
</style>
